import { render } from "./ProviderList.vue?vue&type=template&id=43e63dc7"
import script from "./ProviderList.vue?vue&type=script&lang=js"
export * from "./ProviderList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nisalatp/Projects/Herd/OrangeHRM/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__